<div class="timeline">
  <span class="timeline__header lx-title">
    {{ serialNumber }}{{ monitoringData?.metadata?.deviceType === 'ER' && monitoringData?.metadata?.geotabSerialNumber?.trim() ? '+' : '' }}
  </span>

  <div
    *ngIf="
      segmentsByType.size ||
        timelineType.size ||
        ecmType.size ||
        batteryType.size ||
        monitoringData?.metadata;
      else nodata
    "
    class="timeline__content">
    <device-metadata-section
      *ngIf="monitoringData?.metadata"
      [deviceEncryptionKey]="monitoringData?.deviceEncryptionKey"
      [deviceEvent]="monitoringData?.deviceEvent"
      [deviceVersion]="monitoringData?.deviceVersion"
      [geotabMetadata]="monitoringData?.geotabMetadata"
      [metadata]="monitoringData?.metadata"
      [photos]="monitoringData?.photos"
      (dissociated)="dissociated.emit()"
      (dissociationConfirmed)="dissociationConfirmed.emit()"></device-metadata-section>

    <div
      *ngIf="
        segmentsByType.size ||
          timelineType.size ||
          ecmType.size ||
          batteryType.size;
        else nodata
      "
      class="timeline__content__row-container"
      (mouseenter)="hoverBarActive = true"
      (mouseleave)="hoverBarActive = false"
      (mousemove)="onHover($event)">
      <timestamp-row
        [endDate]="endDate?.getTime()"
        [startDate]="startDate?.getTime()"></timestamp-row>

      <div
        *ngIf="timelineType.size"
        class="timeline_row">
        <span class="timeline__timeline-header">DVR</span>
        <dcc-device-timeline-row
          *ngFor="let timelineKV of timelineType | keyvalue"
          [data]="timelineKV.value"
          [title]="timelineKV.key"></dcc-device-timeline-row>
      </div>

      <div
        *ngIf="ecmType.size"
        class="timeline_row">
        <span class="timeline__timeline-header">ECM</span>
        <dcc-device-timeline-row
          *ngFor="let ecmKV of ecmType | keyvalue"
          [data]="ecmKV.value"
          [title]="ecmKV.key"></dcc-device-timeline-row>
      </div>

      <div class="timeline_row">
        <span class="timeline__timeline-header">Data</span>
        <dcc-device-timeline-row
          *ngFor="let segmentKV of segmentsByType | keyvalue"
          [data]="segmentKV.value"
          [title]="segmentKV.key"></dcc-device-timeline-row>
      </div>

      <div
        *ngIf="enableBatteryView && batteryType.size"
        class="timeline_row">
        <span class="timeline__timeline-header">Battery</span>
        <dcc-device-timeline-row
          *ngFor="let batteryKV of batteryType | keyvalue: originalOrder"
          [data]="batteryKV.value"
          [title]="batteryKV.key"></dcc-device-timeline-row>
      </div>

      <div
        class="timeline__content__hover-bar-tooltip"
        [hidden]="!hoverBarActive"
        [ngStyle]="{ 'left.px': hoverBarTooltipX }">
        {{ hoverBarTime | date: 'MMM d, h:mm a' }}
      </div>
      <div
        class="timeline__content__hover-bar"
        [hidden]="!hoverBarActive"
        [ngStyle]="{ 'left.px': hoverBarX }"></div>
    </div>
  </div>
  <!-- error message to be displayed when there is no data found-->
  <ng-template #nodata>
    <p class="timeline__no-data alert alert-danger text-center">
      {{ errorMessage }}
    </p>
  </ng-template>
</div>
